import { currency } from "@/lib/portalConstants";
import { BUSINESS } from "@/data/site";

export function printInvoice(inv) {
  const rows = inv.line_items
    .map(
      (li) =>
        `<tr><td>${li.description}</td><td style="text-align:center">${li.quantity} ${li.unit}</td><td style="text-align:right">${currency(li.rate)}</td><td style="text-align:right">${currency(li.amount)}</td></tr>`
    )
    .join("");
  const html = `<!doctype html><html><head><title>${inv.invoice_number}</title>
  <style>
    body{font-family:Georgia,serif;color:#2D2C2A;padding:48px;max-width:720px;margin:auto}
    h1{font-size:34px;margin:0}
    .muted{color:#5C5A56}
    table{width:100%;border-collapse:collapse;margin-top:28px}
    th,td{padding:10px 8px;border-bottom:1px solid #e5e2d9;font-size:14px}
    th{text-align:left;color:#63745F;font-size:12px;text-transform:uppercase;letter-spacing:.08em}
    .totals{margin-top:16px;margin-left:auto;width:260px}
    .totals div{display:flex;justify-content:space-between;padding:6px 0;font-size:14px}
    .total{font-weight:bold;font-size:18px;border-top:2px solid #2D2C2A;margin-top:6px;padding-top:10px}
    .head{display:flex;justify-content:space-between;align-items:flex-start}
  </style></head><body>
  <div class="head">
    <div><img src="${window.location.origin}/logo.png" alt="HomeCare by Nicole" style="height:76px;width:auto;display:block;margin-bottom:6px"/><h1>HomeCare by Nicole</h1><p class="muted">${BUSINESS.area}<br/>${BUSINESS.phoneDisplay} · ${BUSINESS.email}</p></div>
    <div style="text-align:right"><h2 style="margin:0">INVOICE</h2><p class="muted">${inv.invoice_number}<br/>Issued: ${inv.issue_date || ""}${inv.due_date ? `<br/>Due: ${inv.due_date}` : ""}</p></div>
  </div>
  <p class="muted" style="margin-top:24px">Bill to</p>
  <p style="margin-top:2px;font-size:18px">${inv.client?.name || ""}</p>
  ${inv.client?.contact_name ? `<p class="muted">${inv.client.contact_name}</p>` : ""}
  <table><thead><tr><th>Description</th><th style="text-align:center">Qty</th><th style="text-align:right">Rate</th><th style="text-align:right">Amount</th></tr></thead><tbody>${rows}</tbody></table>
  <div class="totals">
    <div><span class="muted">Subtotal</span><span>${currency(inv.subtotal)}</span></div>
    ${inv.tax_rate ? `<div><span class="muted">Tax (${inv.tax_rate}%)</span><span>${currency(inv.tax_amount)}</span></div>` : ""}
    <div class="total"><span>Total</span><span>${currency(inv.total)}</span></div>
  </div>
  ${inv.notes ? `<p class="muted" style="margin-top:28px">${inv.notes}</p>` : ""}
  <p class="muted" style="margin-top:40px;text-align:center">Thank you for trusting HomeCare by Nicole.</p>
  <script>window.onload=function(){window.print();}</script>
  </body></html>`;
  const w = window.open("", "_blank");
  w.document.write(html);
  w.document.close();
}

export function printReceipt(inv) {
  const rows = inv.line_items
    .map(
      (li) =>
        `<tr><td>${li.description}</td><td style="text-align:center">${li.quantity} ${li.unit}</td><td style="text-align:right">${currency(li.amount)}</td></tr>`
    )
    .join("");
  const html = `<!doctype html><html><head><title>${inv.receipt_number || "Receipt"}</title>
  <style>
    body{font-family:Georgia,serif;color:#2D2C2A;padding:48px;max-width:720px;margin:auto}
    h1{font-size:34px;margin:0}
    .muted{color:#5C5A56}
    table{width:100%;border-collapse:collapse;margin-top:24px}
    th,td{padding:10px 8px;border-bottom:1px solid #e5e2d9;font-size:14px}
    th{text-align:left;color:#63745F;font-size:12px;text-transform:uppercase;letter-spacing:.08em}
    .head{display:flex;justify-content:space-between;align-items:flex-start}
    .paid{display:inline-block;border:3px solid #2f9e64;color:#2f9e64;padding:6px 18px;border-radius:8px;font-weight:bold;letter-spacing:.15em;transform:rotate(-4deg);font-family:Arial}
    .box{background:#f2f7f3;border:1px solid #cfe3d6;border-radius:10px;padding:16px 18px;margin-top:24px;font-size:14px}
    .box div{display:flex;justify-content:space-between;padding:4px 0}
    .totals{margin-top:16px;margin-left:auto;width:260px}
    .totals div{display:flex;justify-content:space-between;padding:6px 0;font-size:14px}
    .total{font-weight:bold;font-size:18px;border-top:2px solid #2D2C2A;margin-top:6px;padding-top:10px}
  </style></head><body>
  <div class="head">
    <div><img src="${window.location.origin}/logo.png" alt="HomeCare by Nicole" style="height:76px;width:auto;display:block;margin-bottom:6px"/><h1>HomeCare by Nicole</h1><p class="muted">${BUSINESS.area}<br/>${BUSINESS.phoneDisplay} · ${BUSINESS.email}</p></div>
    <div style="text-align:right"><h2 style="margin:0">RECEIPT</h2><p class="muted">Receipt: ${inv.receipt_number || ""}<br/>Invoice: ${inv.invoice_number}<br/>Paid: ${inv.paid_at || ""}</p><p class="paid">PAID</p></div>
  </div>
  <p class="muted" style="margin-top:24px">Received from</p>
  <p style="margin-top:2px;font-size:18px">${inv.paid_by || inv.client?.contact_name || inv.client?.name || ""}</p>
  <p class="muted">For the care of ${inv.client?.name || ""}</p>
  <table><thead><tr><th>Description</th><th style="text-align:center">Qty</th><th style="text-align:right">Amount</th></tr></thead><tbody>${rows}</tbody></table>
  <div class="box">
    <div><span>Payment method</span><strong>${inv.payment_method || "—"}</strong></div>
    <div><span>Payment date</span><strong>${inv.paid_at || "—"}</strong></div>
    <div><span>Received by</span><strong>${inv.paid_by || "—"}</strong></div>
    <div><span>Linked invoice</span><strong>${inv.invoice_number}</strong></div>
  </div>
  <div class="totals">
    <div class="total"><span>Amount paid</span><span>${currency(inv.amount_paid != null ? inv.amount_paid : inv.total)}</span></div>
  </div>
  <p class="muted" style="margin-top:40px;text-align:center">Thank you for your payment. — HomeCare by Nicole</p>
  <script>window.onload=function(){window.print();}</script>
  </body></html>`;
  const w = window.open("", "_blank");
  w.document.write(html);
  w.document.close();
}

const esc = (s) =>
  String(s || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");

export function printWeek(weekLabel, buckets) {  const days = buckets
    .map((b) => {
      const rows =
        b.tasks.length === 0
          ? `<p class="muted" style="margin:4px 0 0;font-size:13px">No visits scheduled</p>`
          : b.tasks
              .map(
                (t) => `<div class="task${t.done ? " done" : ""}">
                  <span class="time">${esc(t.time) || "Any time"}</span>
                  <span class="dot" style="background:${t.dot}"></span>
                  <span class="name">${esc(t.title)}${t.client ? ` <span class="muted">· ${esc(t.client)}</span>` : ""}</span>
                  <span class="tag" style="color:${t.dot}">${esc(t.typeLabel)}</span>
                  ${t.notes ? `<div class="notes muted">${esc(t.notes)}</div>` : ""}
                </div>`
              )
              .join("");
      return `<div class="day"><h3>${esc(b.label)}</h3>${rows}</div>`;
    })
    .join("");
  const html = `<!doctype html><html><head><title>${esc(weekLabel)} — HomeCare by Nicole</title>
  <style>
    body{font-family:Georgia,serif;color:#2D2C2A;padding:40px;max-width:720px;margin:auto}
    h1{font-size:30px;margin:0}
    .muted{color:#5C5A56}
    .head{display:flex;justify-content:space-between;align-items:flex-start;border-bottom:2px solid #8A9A86;padding-bottom:20px}
    .day{margin-top:22px}
    h3{font-size:15px;color:#63745F;text-transform:uppercase;letter-spacing:.08em;margin:0 0 8px;border-bottom:1px solid #e5e2d9;padding-bottom:6px}
    .task{display:flex;align-items:baseline;gap:10px;padding:7px 0;font-size:14px;flex-wrap:wrap}
    .task.done .name,.task.done .time{text-decoration:line-through;color:#a3a19b}
    .time{color:#63745F;font-size:13px;min-width:96px}
    .dot{display:inline-block;width:9px;height:9px;border-radius:99px;flex-shrink:0}
    .name{flex:1}
    .tag{font-size:12px}
    .notes{width:100%;font-size:12.5px;font-style:italic;padding-left:106px;margin-top:-2px}
  </style></head><body>
  <div class="head">
    <div><img src="${window.location.origin}/logo.png" alt="HomeCare by Nicole" style="height:72px;width:auto;display:block;margin-bottom:6px"/><h1>HomeCare by Nicole</h1><p class="muted">${BUSINESS.area}<br/>${BUSINESS.phoneDisplay} · ${BUSINESS.email}</p></div>
    <div style="text-align:right"><h2 style="margin:0;letter-spacing:.12em">WEEKLY<br/>SCHEDULE</h2><p class="muted">${esc(weekLabel)}</p></div>
  </div>
  ${days}
  <p class="muted" style="margin-top:36px;text-align:center;font-size:13px">Questions about this week's schedule? Call or text ${BUSINESS.phoneDisplay}.<br/>— Nicole</p>
  <script>window.onload=function(){window.print();}</script>
  </body></html>`;
  const w = window.open("", "_blank");
  w.document.write(html);
  w.document.close();
}

const fmtDate = (s) => {
  if (!s) return "";
  const d = new Date(String(s).length === 10 ? `${s}T00:00:00` : s);
  return d.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric", year: "numeric" });
};

const fmtDateTime = (s) => {
  if (!s) return "";
  const d = new Date(String(s).replace(" ", "T"));
  return `${d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })} · ${d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" })}`;
};

export function printCareProfile(client, tasks, careLogs, incidents = []) {
  const generated = new Date().toLocaleString("en-US", { month: "long", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" });
  const descriptors = [
    client.approx_age && `Age ~${client.approx_age}`,
    client.cognitive,
    client.mobility,
  ].filter(Boolean);
  const needs = (client.care_needs || [])
    .map((n) => `<span class="chip">${esc(n)}</span>`)
    .join("");
  const visits = (tasks || [])
    .map((t) => {
      const time = t.start_time ? `${t.start_time}${t.end_time ? " – " + t.end_time : ""}` : "Any time";
      return `<div class="row"><span class="d">${fmtDate(t.date)}</span><span class="t">${esc(time)}</span><span class="w">${esc(t.title)}${t.done ? " <span class='muted'>(completed)</span>" : ""}</span></div>`;
    })
    .join("");
  const logs = (careLogs || [])
    .slice(0, 30)
    .map((l) => {
      const care = [...(l.personal_care || []), ...(l.assisted_with || []), ...(l.housekeeping || [])].map(esc).join(" · ");
      return `<div class="log">
        <div class="loghead"><span class="d">${fmtDate(l.date)}</span>${l.wellbeing ? `<span class="wb">${esc(l.wellbeing)}</span>` : ""}</div>
        ${care ? `<p class="care">${care}</p>` : ""}
        ${l.meals_hydration ? `<p class="muted">Meals & hydration: ${esc(l.meals_hydration)}</p>` : ""}
        ${l.summary ? `<p>${esc(l.summary)}</p>` : ""}
      </div>`;
    })
    .join("");
  const incidentRows = (incidents || [])
    .map((i) => `<div class="log">
        <div class="loghead"><span class="d">${fmtDateTime(i.occurred_at)}</span><span class="wb" style="background:${i.resolved ? "#eef2ec" : "#fbe9ea"};color:${i.resolved ? "#63745F" : "#B25B66"}">${i.resolved ? "Resolved" : "Open"}</span></div>
        <p><strong>What happened:</strong> ${esc(i.what_happened)}</p>
        ${i.action_taken ? `<p class="muted">Action taken: ${esc(i.action_taken)}</p>` : ""}
        ${i.notified ? `<p class="muted">Notified: ${esc(i.notified)}</p>` : ""}
        ${i.outcome ? `<p class="muted">Outcome: ${esc(i.outcome)}</p>` : ""}
        ${i.follow_up ? `<p class="muted">Follow-up: ${esc(i.follow_up)}</p>` : ""}
      </div>`)
    .join("");
  const html = `<!doctype html><html><head><title>Care Profile — ${esc(client.name)} — HomeCare by Nicole</title>
  <style>
    body{font-family:Georgia,serif;color:#2D2C2A;padding:40px;max-width:720px;margin:auto}
    h1{font-size:30px;margin:0}
    h2{font-size:15px;color:#63745F;text-transform:uppercase;letter-spacing:.08em;margin:28px 0 10px;border-bottom:1px solid #e5e2d9;padding-bottom:6px}
    .muted{color:#5C5A56}
    .head{display:flex;justify-content:space-between;align-items:flex-start;border-bottom:2px solid #8A9A86;padding-bottom:20px}
    .desc{display:flex;flex-wrap:wrap;gap:8px;margin-top:12px}
    .pill{background:#eef2ec;color:#63745F;border-radius:99px;padding:4px 12px;font-size:12.5px}
    .chip{display:inline-block;background:#f6ede7;color:#A9714B;border-radius:99px;padding:4px 12px;font-size:12.5px;margin:0 6px 6px 0}
    .grid{font-size:14px;line-height:1.7;margin-top:6px}
    .row{display:flex;gap:14px;padding:6px 0;font-size:13.5px;border-bottom:1px dotted #e5e2d9}
    .d{font-weight:bold;min-width:130px}
    .t{color:#63745F;min-width:110px}
    .w{flex:1}
    .log{border-bottom:1px dotted #e5e2d9;padding:10px 0;font-size:13.5px}
    .loghead{display:flex;justify-content:space-between;align-items:baseline}
    .wb{font-size:12px;color:#63745F;background:#eef2ec;border-radius:99px;padding:2px 10px}
    .care{color:#5C5A56;font-size:12.5px;margin:4px 0}
    .log p{margin:4px 0}
  </style></head><body>
  <div class="head">
    <div><img src="${window.location.origin}/logo.png" alt="HomeCare by Nicole" style="height:72px;width:auto;display:block;margin-bottom:6px"/><h1>HomeCare by Nicole</h1><p class="muted">${BUSINESS.area}<br/>${BUSINESS.phoneDisplay} · ${BUSINESS.email}</p></div>
    <div style="text-align:right"><h2 style="margin:0;letter-spacing:.12em;border:0">CLIENT<br/>CARE PROFILE</h2><p class="muted">Generated ${generated}</p></div>
  </div>

  <h2>Client</h2>
  <p style="font-size:20px;margin:0 0 4px"><strong>${esc(client.name)}</strong> ${client.active === false ? '<span class="muted">(inactive)</span>' : ""}</p>
  ${descriptors.length ? `<div class="desc">${descriptors.map((d) => `<span class="pill">${esc(d)}</span>`).join("")}</div>` : ""}
  <div class="grid">
    ${client.address ? `<div>Address: ${esc(client.address)}</div>` : ""}
    ${client.contact_name ? `<div>Authorized contact: ${esc(client.contact_name)}${client.contact_relationship ? ` (${esc(client.contact_relationship)})` : ""}${client.contact_phone ? ` · ${esc(client.contact_phone)}` : ""}</div>` : ""}
    ${client.notes ? `<div class="muted"><em>${esc(client.notes)}</em></div>` : ""}
  </div>

  ${needs ? `<h2>Care needs</h2><div>${needs}</div>` : ""}

  ${visits ? `<h2>Scheduled visits</h2>${visits}` : ""}

  <h2>Care log ${(careLogs || []).length > 30 ? "(most recent 30)" : ""}</h2>
  ${logs || '<p class="muted">No care visits logged yet.</p>'}

  <h2>Incident reports</h2>
  ${incidentRows || '<p class="muted">No incidents on record.</p>'}

  <p class="muted" style="margin-top:36px;text-align:center;font-size:12.5px">Prepared by HomeCare by Nicole · ${BUSINESS.phoneDisplay}<br/>This record reflects non-medical, private-duty home care services.</p>
  <script>window.onload=function(){window.print();}</script>
  </body></html>`;
  const w = window.open("", "_blank");
  w.document.write(html);
  w.document.close();
}
